import React from "react";
import { connect } from "react-redux";
import { basketClear } from "../../../actions/orders";
import { Button } from "react-bootstrap";

const BasketResetOrder = ({ value, dispatch }) => {
  const resetOrderAndHideBasket = () => {
    dispatch({ type: "TOGGLE_BASKET_DROPDOWN" });
    dispatch(basketClear());
  };
  return (
    <Button
      className="btn btn-link pull-right btn-reset"
      onClick={() => resetOrderAndHideBasket()}
    >
      {value}
    </Button>
  );
};

export default connect()(BasketResetOrder);



// WEBPACK FOOTER //
// ./src/components/new-order/basket/basket-reset-order.jsx